import { NewFeedbackItem, sendSlackMessage } from "./web-api";

export const sendFeedbackToSlack = async (authHeader: string, feedback: NewFeedbackItem, user: { firstName?: string; lastName?: string }, rule: any) => {
  try {
    const message = `New feedback received: ${feedback.isPositive ? "Like" : "Dislike"} from user ${user.firstName} ${user.lastName}, Rule: ${rule.rule.name}${feedback.details ? ", Details: " + feedback.details : ""}`

    const response = await sendSlackMessage(authHeader, message);

    if (!response.ok) {
      console.error(`Failed to send message to Slack: ${response.statusText}`);
    }
  } catch (err) {
    console.error("Error while sending message to Slack");
    console.error(err);
  }
}